import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetPostPreviewFailed, EGetPostPreviewActionType } from './types';

export const getPostPreviewFailed: () => TGetPostPreviewFailed = actionGenerator<EGetPostPreviewActionType.Failed>(
  EGetPostPreviewActionType.Failed,
);
